import ReactDOM from 'react-dom/client';

// components
import App from './App';
import './i18n';

// styles
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from 'stores/store';
import Main from 'Main';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<Provider store={store}>
		<Main />
	</Provider>,
);
